/** @ngInject */
function baSidebarServiceDecorator($delegate, gettextCatalog, $state, CMSAuthService) {
    let oldGedMenu = $delegate.getMenuItems;
    let oldShouldMenuBeCollapsed = $delegate.shouldMenuBeCollapsed;
    let lockAutoCollapse = false;

    function translateTitles(menuItems) {
        menuItems.forEach(function (item) {

            if (item.title) {
                item.title = gettextCatalog.getString(item.title)
            }

            if(item.subMenu){
                translateTitles(item.subMenu)
            }
        });
    }

    function isAllowed(userRoles, stateRoles){
        if(!stateRoles){
            return true;
        }

        let isAllowed = false;
        userRoles.forEach(function(userRole){
            if(stateRoles.indexOf(userRole) !== -1){
                isAllowed = true;
            }
        });
        return isAllowed;
    }

    $delegate.getMenuItems = function(){
        let menuItems = oldGedMenu.apply($delegate, arguments);
        let filteredMenuItems = [];
        let user = CMSAuthService.getUser();

        menuItems.forEach(function(item){
           let state = $state.get(item.name);

           if(!state){
               /* Menu items like developer zone, manually added (static states) */
               filteredMenuItems.push(item);
           }

           if(state && isAllowed(user.roles, state.sidebarMeta.allow)){
               filteredMenuItems.push(item);
           }
        });

        translateTitles(filteredMenuItems);

        return filteredMenuItems;
    };


    $delegate.lockAutoCollapse = (lock) => {
      lockAutoCollapse = lock;
    };

    $delegate.shouldMenuBeCollapsed = () => {
        if(lockAutoCollapse) {
            return true;
        }
        return oldShouldMenuBeCollapsed();
    };

    return $delegate;
}

export default baSidebarServiceDecorator


// WEBPACK FOOTER //
// ./src/cmsCore/BlurAdmin/baSidebarDecorator/baSidebarServiceDecorator.js